import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import axios from '../../Helpers/Axiosbase';
import * as actions from '../../Store/Actions'
import useReactRouter from 'use-react-router';
import MaterialTable from 'material-table';
import Switch from '@material-ui/core/Switch';
import { Button, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import { makeStyles, ThemeProvider, createMuiTheme, decomposeColor } from '@material-ui/core/styles';

//Stepper

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';

//Merge
var merge = require('lodash.merge');
var unset = require('lodash.unset');

const theme = createMuiTheme({});

const useStyles = makeStyles(theme => ({
    div: {
        marginRight: '15px',
        // float: 'right',
    },

    //Stepper
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    stepperdiv: {
        marginRight: '15px',
        float: 'right',
    },
}));

//Stepper

function getSteps() {
    return ['Add Quick Actions', 'Add Menu Options'];
}

//Alert

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function NavmenuForm(props) {

    const classes = useStyles();
    const { location, history } = useReactRouter();
    const reduxAuth = useSelector((state) => state.auth)
    const appcomponent = useSelector((state) => state.appcomponent)
    const dispatch = useDispatch();

    //success alert

    const [openalert, setOpenAlert] = React.useState({
        open: false,
        msg: 'Configuration Saved',
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert({
            open: false,
        });
    };

    //Stepper
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    //Location Data

    const [locationdata, setlocationdata] = React.useState({
        locationdata: location.state
    })

    //Quick Actions static JSON

    const [jsonObj] = React.useState({
        _id: '',
        componentContextCode: '',
        domain: '',
        entityType: '',
        context1: '',
        context2: '',
        context3: '',
        relationship: '',
        role: '',
        app: '',
        isDuplicate: '',
        environmentId: '',
        isDuplicate: false,
        isPublished: true,
        jsonDocument: {
            id: "",
            name: "",
            type: "",
            // properties:"",
            data: {
                contexts: [{
                    context: {
                        component: "_DEFAULT",
                        role: "_DEFAULT",
                        tenant: "_DEFAULT",
                        domain: "_DEFAULT",
                        app: "_DEFAULT",
                        entityType: "_DEFAULT",
                        country: "_DEFAULT",
                        channel: "_DEFAULT",
                        relationship: "_DEFAULT",
                        user: "_DEFAULT"
                    },
                    jsonData: {}
                }]
            }
        }
    })

    const handleNext = (event) => {
        if (event === 'Next') {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setOpenNextSelection({
                open: true
            })

        }
        else {
            reduxAuth.fullscreentoggle=false
            history.push('./Config')
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        setOpenNextSelection({
            open: false
        })
    };

    //End Stepper

    const [openNextSelection, setOpenNextSelection] = React.useState({
        open: false
    })

    // Set Quick Actions And Set Menu Options
    const [QuickActions, setQuickActions] = React.useState({
        QuickActions: []
    })

    const [MenuOptions, setMenuOptions] = React.useState({
        MenuOptions: []
    })

    const [state, setState] = React.useState({
        columns: [
            { title: 'Action Name', field: 'name' },
            { title: 'Action Text', field: 'text' },
            { title: 'Parent Name', field: 'parentname', defaultSort: 'asc' },
            { title: 'Entity Type', field: 'contextData.itemContext.type' },
            { title: 'Display Sequence', field: 'displaySequence', type: 'numeric' },
            {
                title: 'Visible',
                field: 'visible',
                editComponent: props => (
                    <Switch checked={props.value} onChange={e => props.onChange(!props.value)} />
                ),
                render: rowData => {
                    if (rowData.visible === "true" || rowData.visible === true) {

                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = false
                            handlequickactionsedit(rowData)
                        }} />
                    }
                    else {
                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = true
                            handlequickactionsedit(rowData)
                        }} />
                    }
                }
            },
        ]
    });

    const [menustate, setMenuState] = React.useState({
        columns: [
            { title: 'App Name', field: 'name' },
            { title: 'Parent App Name', field: 'parentapp', editable: 'never', defaultSort: 'asc' },
            { title: 'Main App Name', field: 'mainapp', editable: 'never', defaultSort: 'asc' },
            { title: 'Display Sequence', field: 'displaySequence', type: 'numeric' },
            {
                title: 'Visible',
                field: 'visible',
                editComponent: props => (
                    <Switch checked={props.value} onChange={e => props.onChange(!props.value)} />
                ),
                render: rowData => {
                    if (rowData.visible === "true" || rowData.visible === true) {

                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = false
                            handlemenuoptionsedit(rowData)
                        }} />
                    }
                    else {
                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = true
                            handlemenuoptionsedit(rowData)
                        }} />
                    }
                }
            },
        ]
    });

    //update config API
    const updateConfigAPI = (event) => {

        //update Config

        let url = "configurationUpdate"
        let postdata = null;
        if (event === "add") {
            postdata = {
                _id: props.data._id,
                jsonDocument: jsonObj.jsonDocument,
                isPublished: false,
                componentContextCode: props.data.componentContextCode,
                domain: props.data.domain,
                entityType: props.data.entityType,
                context1: props.data.context1,
                context2: props.data.context2,
                context3: props.data.context3,
                relationship: props.data.relationship,
                role: props.data.role,
                app: props.data.app,
                isDuplicate: props.data.isDuplicate,
                environmentId: props.data.environmentId,
                token: reduxAuth.token,
                userId: reduxAuth.userId
            };
        }
        else {
            location.state.isPublished = false;
            postdata = {
                ...location.state,
                token: reduxAuth.token,
                userId: reduxAuth.userId
            }
        }


        axios.post(url, postdata)
            .then(editConfigResponse => {
                setOpenAlert({
                    open: true
                })
            })
            .catch(err => {
                console.log(err);
                if (typeof err.response != "object") {
                }
                else {
                    if (err.response.status === 403) {
                        dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                    }
                }
            });

    }

    const deleteparent = (copynewdata) => {
        let deldata = copynewdata;
        delete deldata['parentname']
        return deldata;
    }

    //Add QuickActions

    const handlequickactionsadd = (newdata) => {
        let addjson = {};
        let disseq = newdata.displaySequence;
        newdata.displaySequence = parseInt(disseq, 10)
        var oldobject = QuickActions.QuickActions;
        var newobjject = oldobject.concat(newdata);
        let name = newdata.name;
        try {
            if (newdata.hasOwnProperty("entitytype")) {
                let contextdata = {
                    "contextData": {
                        "itemContext": {
                            "type": newdata.contextData.itemContext.type
                        }
                    }
                }
                newdata = merge(newdata, contextdata)
            }

        } catch (error) { }


        try {

            //Check if the oldobject is blank
            if (location.state) {

                if (location.state.jsonDocument == '') {
                    location.state.jsonDocument = jsonObj.jsonDocument
                }

                if (oldobject.length === 0 && (location.state.jsonDocument.data.contexts[0].jsonData != null && location.state.jsonDocument.data.contexts[0].jsonData.length != 0)) {
                    let quickdata = locationdata.locationdata.jsonDocument.data.contexts[0].jsonData.config;
                    var newjson = {
                        "quick-actions": {
                            "subNavMenu": {
                            }
                        }
                    };

                    newjson["quick-actions"].subNavMenu[newdata.parentname] = {
                        "actions": {
                            [name]: newdata
                        }
                    };

                    let mergedJSON = { ...quickdata, ...newjson };
                    location.state.jsonDocument.data.contexts[0].jsonData.config = mergedJSON
                }

                if (oldobject.length != 0 && (location.state.jsonDocument.data.contexts[0].jsonData != null && location.state.jsonDocument.data.contexts[0].jsonData.length != 0)) {
                    let quickdata = locationdata.locationdata.jsonDocument.data.contexts[0].jsonData.config;
                    if (quickdata["quick-actions"].subNavMenu) {
                        if (quickdata["quick-actions"].subNavMenu[newdata.parentname]) {
                            var existingactions = quickdata["quick-actions"].subNavMenu[newdata.parentname].actions;
                            var newaction = {
                                [name]: newdata
                            }
                            quickdata["quick-actions"].subNavMenu[newdata.parentname].actions = { ...existingactions, ...newaction };
                        }
                        else {
                            quickdata["quick-actions"].subNavMenu[newdata.parentname] = {
                                "actions": {
                                    [name]: newdata
                                }
                            };
                        }
                        location.state.jsonDocument.data.contexts[0].jsonData.config = quickdata
                        console.log("called")
                    }
                    else {
                        console.log("error");
                    }
                }

                if (location.state.jsonDocument.data.contexts[0].jsonData == null || location.state.jsonDocument.data.contexts[0].jsonData.length === 0) {
                    var newjson = {
                        "config": {
                            "quick-actions": {
                                "subNavMenu": {
                                }
                            }
                        }
                    };

                    newjson.config["quick-actions"].subNavMenu[newdata.parentname] = {
                        "actions": {
                            [name]: newdata
                        }
                    };
                    location.state.jsonDocument.data.contexts[0].jsonData = newjson
                }


                //call updateconfigapi function
                updateConfigAPI();
            }

            //New Config -Add
            if (location.state === undefined) {
                jsonObj.jsonDocument.id = props.data.computedName;
                jsonObj.jsonDocument.name = props.data.computedName;
                jsonObj.jsonDocument.type = "UiConfig";
                jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
                jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
                jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
                jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
                jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
                jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
                jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
                jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

                jsonObj._id = props.data._id;
                jsonObj.isPublished = false;
                jsonObj.componentContextCode = props.data.componentContextCode;
                jsonObj.domain = props.data.domain;
                jsonObj.entityType = props.data.entityType;
                jsonObj.context1 = props.data.context1;
                jsonObj.context2 = props.data.context2;
                jsonObj.context3 = props.data.context3;
                jsonObj.relationship = props.data.relationship;
                jsonObj.role = props.data.role;
                jsonObj.app = props.data.app;
                jsonObj.isDuplicate = props.data.isDuplicate;
                jsonObj.environmentId = props.data.environmentId;

                var newjson = {
                    "config": {
                        "quick-actions": {
                            "subNavMenu": {
                            }
                        }
                    }
                };

                newjson.config["quick-actions"].subNavMenu[newdata.parentname] = {
                    "actions": {
                        [name]: newdata
                    }
                };

                jsonObj.jsonDocument.data.contexts[0].jsonData = newjson;
                location.state = jsonObj
                //call updateconfigapi function
                updateConfigAPI("add");
            }
        } catch (error) { }

        //Set Quickactions state
        setQuickActions({
            QuickActions: newobjject
        })

        getoptionslist();


    }
    //Edit QuikActions
    const handlequickactionsedit = (newdata) => {
        // console.log("newdata:",newdata)
        let disseq = newdata.displaySequence;
        newdata.displaySequence = parseInt(disseq, 10)
        var oldobject = QuickActions.QuickActions;
        var newobjject = oldobject.concat(newdata);
        let name = newdata.name;
        // const realobj=newdata;
        // let delnewdat=deleteparent(realobj);

        try {
            if (newdata.hasOwnProperty("entitytype")) {
                let contextdata = {
                    "contextData": {
                        "itemContext": {
                            "type": newdata.contextData.itemContext.type
                        }
                    }
                }
                newdata = merge(newdata, contextdata)
            }

        } catch (error) { }



        if (location.state) {
            if ((location.state.jsonDocument.data.contexts[0].jsonData != null && location.state.jsonDocument.data.contexts[0].jsonData.length != 0)) {
                let quickdata = locationdata.locationdata.jsonDocument.data.contexts[0].jsonData.config;


                if (quickdata["quick-actions"].subNavMenu) {
                    if (quickdata["quick-actions"].subNavMenu[newdata.parentname]) {
                        var existingactions = quickdata["quick-actions"].subNavMenu[newdata.parentname].actions;
                        var newaction = {
                            [name]: newdata

                        }
                        quickdata["quick-actions"].subNavMenu[newdata.parentname].actions = { ...existingactions, ...newaction };
                    }
                    else {
                        quickdata["quick-actions"].subNavMenu[newdata.parentname] = {
                            "actions": {
                                [name]: newdata
                            }
                        };
                    }
                    // const dummquick=quickdata;
                    // unset(dummquick,dummquick["quick-actions"].subNavMenu[newdata.parentname].actions[name])
                    // console.log("dummquick",dummquick)
                    // console.log("quickdata",quickdata)
                    location.state.jsonDocument.data.contexts[0].jsonData.config = quickdata
                    getoptionslist();
                    updateConfigAPI();
                }
                else {
                    console.log("error");
                }
            }
        }

        if (location.state === undefined) {
            jsonObj.jsonDocument.id = props.data.computedName;
            jsonObj.jsonDocument.name = props.data.computedName;
            jsonObj.jsonDocument.type = "UiConfig";
            jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
            jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
            jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
            jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
            jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
            jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
            jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
            jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

            jsonObj._id = props.data._id;
            jsonObj.isPublished = false;
            jsonObj.componentContextCode = props.data.componentContextCode;
            jsonObj.domain = props.data.domain;
            jsonObj.entityType = props.data.entityType;
            jsonObj.context1 = props.data.context1;
            jsonObj.context2 = props.data.context2;
            jsonObj.context3 = props.data.context3;
            jsonObj.relationship = props.data.relationship;
            jsonObj.role = props.data.role;
            jsonObj.app = props.data.app;
            jsonObj.isDuplicate = props.data.isDuplicate;
            jsonObj.environmentId = props.data.environmentId;

            var newjson = {
                "config": {
                    "quick-actions": {
                        "subNavMenu": {
                        }
                    }
                }
            };

            newjson.config["quick-actions"].subNavMenu[newdata.parentname] = {
                "actions": {
                    [name]: newdata,
                    "contextData": {
                        "itemContext": {
                            "type": newdata.entitytype
                        }
                    }
                }
            };

            jsonObj.jsonDocument.data.contexts[0].jsonData = newjson;
            location.state = jsonObj
            getoptionslist();
            //call updateconfigapi function
            updateConfigAPI("add");
        }
    }

    //Delete QuickAction
    const handlequickactionsdelete = (data) => {
        let config = location.state.jsonDocument.data.contexts[0].jsonData.config['quick-actions'].subNavMenu[data.parentname].actions;
        let del = unset(config, data.name)
        location.state.jsonDocument.data.contexts[0].jsonData.config['quick-actions'].subNavMenu[data.parentname].action = config.actions
        getoptionslist();
        updateConfigAPI();
    }

    //Add Menuoptions
    const handlemenuoptionsedit = (newdata) => {
        let disseq = newdata.displaySequence;
        newdata.displaySequence = parseInt(disseq, 10)
        let mergedJSON = null;
        let nullstate = false;
        let notnullstate = false;
        if (location.state) {
            if (location.state.jsonDocument == '') {
                location.state.jsonDocument = jsonObj.jsonDocument
            }
            if (location.state.jsonDocument.data.contexts[0].jsonData == null || location.state.jsonDocument.data.contexts[0].jsonData.length === 0) {
                nullstate = true

                if (!Object.prototype.hasOwnProperty.call(newdata, 'parentapp') && !Object.prototype.hasOwnProperty.call(newdata, 'mainapp')) {
                    var newjson = {
                        "config":
                        {
                            [newdata.name]: newdata
                        }
                    };
                    mergedJSON = newjson
                }
                if (Object.prototype.hasOwnProperty.call(newdata, 'parentapp') && !Object.prototype.hasOwnProperty.call(newdata, 'mainapp')) {
                    var newjson = {
                        "config": {
                            [newdata.parentapp]: {
                                "subNavMenu": {
                                    [newdata.name]: newdata
                                }
                            }
                        }
                    }
                    mergedJSON = newjson
                }
                if (Object.prototype.hasOwnProperty.call(newdata, 'parentapp') && Object.prototype.hasOwnProperty.call(newdata, 'mainapp')) {
                    var newjson = {
                        "config": {
                            [newdata.mainapp]: {
                                "subNavMenu": {
                                    [newdata.parentapp]: {
                                        "actions": {
                                            [newdata.name]: newdata
                                        }
                                    }
                                }
                            }
                        }
                    }
                    mergedJSON = newjson
                }
                // mergedJSON = newjson
            }
            if (location.state.jsonDocument.data.contexts[0].jsonData !== null && location.state.jsonDocument.data.contexts[0].jsonData.length !== 0) {
                notnullstate = true;
                let customdata = location.state.jsonDocument.data.contexts[0].jsonData.config;
                if (!Object.prototype.hasOwnProperty.call(newdata, 'parentapp') && !Object.prototype.hasOwnProperty.call(newdata, 'mainapp')) {
                    var newjson = {
                        [newdata.name]: newdata
                    }
                    mergedJSON = merge(customdata, newjson)
                }
                if (Object.prototype.hasOwnProperty.call(newdata, 'parentapp') && !Object.prototype.hasOwnProperty.call(newdata, 'mainapp')) {
                    var newjson = {
                        [newdata.parentapp]: {
                            "subNavMenu": {
                                [newdata.name]: newdata
                            }
                        }
                    }
                    mergedJSON = merge(customdata, newjson)
                }
                if (Object.prototype.hasOwnProperty.call(newdata, 'parentapp') && Object.prototype.hasOwnProperty.call(newdata, 'mainapp')) {
                    var newjson = {
                        [newdata.mainapp]: {
                            "subNavMenu": {
                                [newdata.parentapp]: {
                                    "actions": {
                                        [newdata.name]: newdata
                                    }
                                }
                            }
                        }
                    }
                    mergedJSON = merge(customdata, newjson)
                }

            }
            if (nullstate === true && mergedJSON !== null) {
                location.state.jsonDocument.data.contexts[0].jsonData = mergedJSON;
            }
            if (notnullstate === true && mergedJSON !== null) {
                location.state.jsonDocument.data.contexts[0].jsonData.config = mergedJSON;
            }
            if (mergedJSON !== null) {
                updateConfigAPI();
            }
        }

        //New Config -Add
        if (location.state === undefined) {
            jsonObj.jsonDocument.id = props.data.computedName;
            jsonObj.jsonDocument.name = props.data.computedName;
            jsonObj.jsonDocument.type = "UiConfig";
            jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
            jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
            jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
            jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
            jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
            jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
            jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
            jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

            jsonObj._id = props.data._id;
            jsonObj.isPublished = false;
            jsonObj.componentContextCode = props.data.componentContextCode;
            jsonObj.domain = props.data.domain;
            jsonObj.entityType = props.data.entityType;
            jsonObj.context1 = props.data.context1;
            jsonObj.context2 = props.data.context2;
            jsonObj.context3 = props.data.context3;
            jsonObj.relationship = props.data.relationship;
            jsonObj.role = props.data.role;
            jsonObj.app = props.data.app;
            jsonObj.isDuplicate = props.data.isDuplicate;
            jsonObj.environmentId = props.data.environmentId;

            if (!Object.prototype.hasOwnProperty.call(newdata, 'parentapp') && !Object.prototype.hasOwnProperty.call(newdata, 'mainapp')) {
                var newjson = {
                    "config":
                    {
                        [newdata.name]: newdata
                    }
                };
                mergedJSON = newjson
            }
            if (Object.prototype.hasOwnProperty.call(newdata, 'parentapp') && !Object.prototype.hasOwnProperty.call(newdata, 'mainapp')) {
                var newjson = {
                    "config": {
                        [newdata.parentapp]: {
                            "subNavMenu": {
                                [newdata.name]: newdata
                            }
                        }
                    }
                }
                mergedJSON = newjson
            }
            if (Object.prototype.hasOwnProperty.call(newdata, 'parentapp') && Object.prototype.hasOwnProperty.call(newdata, 'mainapp')) {
                var newjson = {
                    "config": {
                        [newdata.mainapp]: {
                            "subNavMenu": {
                                [newdata.parentapp]: {
                                    "actions": {
                                        [newdata.name]: newdata
                                    }
                                }
                            }
                        }
                    }
                }
                mergedJSON = newjson
            }
            // mergedJSON = newjson
            jsonObj.jsonDocument.data.contexts[0].jsonData = newjson;
            location.state = jsonObj
            //call updateconfigapi function
            updateConfigAPI("add");

        }
        getoptionslist();

    }


    //Global Variable
    let qresult = null;
    let qqresult = null;
    var result = null;
    let map = {};
    let quickresult = null;



    //Function
    const getoptionslist = () => {


        let baseconfig = null
        let customconfig = null;
        //Base Configurations Get
        let url = "baseConfigurationGet"
        let postdata = {
            userId: reduxAuth.userId,
            token: reduxAuth.token,
            environmentId: appcomponent.selectedEnvironment.tenantId,
            componentContextCode: appcomponent.selectedComponent.componentContextCode
        }

        axios.post(url, postdata)
            .then(baseConfigResponse => {
                baseconfig = baseConfigResponse.data.response[0].jsonDocument.data.contexts[0].jsonData.config;
                map = baseconfig
                if (location.state) {
                    if (location.state.jsonDocument != '') {
                        if (location.state.jsonDocument.data.contexts[0].jsonData !== null && location.state.jsonDocument.data.contexts[0].jsonData.length != 0) {
                            customconfig = location.state.jsonDocument.data.contexts[0].jsonData.config;

                            map = merge(baseconfig, customconfig)
                        }

                        if (location.state.jsonDocument.data.contexts[0].jsonData == null || location.state.jsonDocument.data.contexts[0].jsonData.length === 0) {
                            map = baseconfig;
                        }
                    }

                    if (location.state.jsonDocument == '') {
                        map = baseconfig
                        quickresult = Object.keys(baseconfig).map((key) => baseconfig[key]);
                        getQuickactionslist();
                    }

                    //Menu options
                    getMenuoptionlist();

                    //Quick Options
                    if (location.state.jsonDocument != '') {
                        if (location.state.jsonDocument.data.contexts[0].jsonData !== null && location.state.jsonDocument.data.contexts[0].jsonData.length != 0) {
                            let qutomconfig = Object.keys(customconfig).map((key) => customconfig[key])
                            let qbaseconfig = Object.keys(baseconfig).map((key) => baseconfig[key])
                            quickresult = merge(qbaseconfig, qutomconfig)
                            getQuickactionslist();
                        }
                    }

                }

                if (location.state === undefined) {
                    map = baseconfig
                    getMenuoptionlist();

                    quickresult = Object.keys(baseconfig).map((key) => baseconfig[key]);
                    getQuickactionslist();

                }
            })
            .catch(err => {
                if (typeof err.response != "object") {
                    console.log(err);
                }
                else {
                    if (err.response.status === 403) {
                        dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                    }
                }
            });
    }

    const getMenuoptionlist = () => {
        let varsubmenuchild = [];
        let vargetmchild = [];
        let varchildarray = [];
        let finalmenuarray = [];
        //Menu Options
        result = Object.keys(map).map((key) => {
            let object = map[key];
            object.name = key;
            if (object.name !== "quick-actions") {
                try {
                    if (object.hasOwnProperty("subNavMenu")) {
                        try {
                            varsubmenuchild = varsubmenuchild.concat(Object.keys((object.subNavMenu)).map((keymap) => {
                                let submenuchild = object.subNavMenu[keymap];
                                vargetmchild = vargetmchild.concat(Object.keys(submenuchild).map((mchild) => {
                                    let getmchild = [];
                                    if (mchild == "actions") {
                                        getmchild = submenuchild[mchild];
                                        if (varchildarray.length === 0) {
                                            varchildarray = (Object.keys(getmchild).map((gmchild) => {
                                                let actionschild = getmchild[gmchild];
                                                actionschild.name = gmchild
                                                actionschild.parentapp = keymap
                                                actionschild.mainapp = key
                                                return actionschild;

                                            }))
                                        }
                                        else {

                                            varchildarray = varchildarray.concat(Object.keys(getmchild).map((gmchild) => {
                                                let actionschild = getmchild[gmchild];
                                                actionschild.name = gmchild
                                                actionschild.parentapp = keymap
                                                actionschild.mainapp = key
                                                return actionschild;
                                            }))
                                        }
                                    }
                                    return getmchild;
                                }))
                                object.subNavMenu[keymap].name = keymap
                                object.subNavMenu[keymap].parentapp = object.name;
                                return object.subNavMenu[keymap];
                            }))
                            // }
                        } catch (error) {
                            console.log("can not read property")
                        }
                    }
                } catch (error) {
                    console.log("Don't have Property")
                }
            }

            return object;

        });
        finalmenuarray = result.concat(varsubmenuchild).concat(varchildarray)
        setMenuOptions({
            MenuOptions: finalmenuarray
        })
    }

    const getQuickactionslist = () => {

        quickresult.map(data => {

            try {
                if (data.name === "quick-actions") {
                    try {
                        if (data.hasOwnProperty("subNavMenu")) {
                            //Refactor
                            let refactor = [];
                            let subnavmenu = data.subNavMenu
                            Object.keys(subnavmenu).map((subkey) => {
                                let subkeyobj = subnavmenu[subkey].actions;

                                refactor = refactor.concat(Object.keys(subkeyobj).map((subkeyobjkey) => {
                                    let recobject = subkeyobj[subkeyobjkey]
                                    recobject.name = subkeyobjkey
                                    recobject.parentname = subkey
                                    return recobject
                                }))

                            })

                            let refinalarr = [];
                            refinalarr = refactor;

                            setQuickActions({
                                QuickActions: refinalarr
                            })
                        }
                    } catch (error) { }
                }
                else {
                }
            } catch (error) {
                console.log("error:")
            }
        })

    }

    useEffect(() => {

        getoptionslist();

    }, []);

    return (
        <div>
            {openalert.open ?
                <Snackbar
                    open={openalert.open} autoHideDuration={3000}
                    onClose={handleClose}>
                    <Alert
                        severity={"success"}
                        color={"info"}
                        variant="outlined">
                        Configuration Saved..
                        </Alert>
                </Snackbar>
                : null}
            <div className={classes.root}>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <div className={classes.stepperdiv}>
                    {activeStep === steps.length ? null : (
                        <div>
                            <div>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                    className={classes.backButton}
                                    style={{ fontSize: '0.700rem', fontWeight: 600 }}
                                    startIcon={<ArrowBackIosIcon style={{ fontSize: 10 }} />}
                                >
                                    Back
                                 </Button>
                                <Button variant="contained"
                                    size="small"
                                    style={{ fontSize: '0.700rem', fontWeight: 600 }}
                                    color="primary"
                                    onClick={() => handleNext(activeStep === steps.length - 1 ? 'Back To Search Result' : 'Next')}
                                    startIcon={activeStep === steps.length - 1 ? <SettingsBackupRestoreIcon /> : <NavigateNextIcon />}
                                >
                                    {activeStep === steps.length - 1 ? 'Back To Search Result' : 'Next'}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {openNextSelection.open ?
                <div style={{ marginTop: '40px' }}>
                    <MaterialTable
                        title="Menu Options"
                        columns={menustate.columns}
                        data={MenuOptions.MenuOptions}
                        options={{
                            search: true,
                            sorting: true,
                            pageSize: 20,
                            pageSizeOptions: [20, 30, 50, 100],
                            padding:'dense'
                        }}
                        editable={{
                            onRowUpdate: (newData) =>
                                new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                        handlemenuoptionsedit(newData);
                                    }, 600);
                                }),
                        }}
                    /></div> : <div style={{ marginTop: '40px' }}>

                    <MaterialTable
                        title="Quick Actions Button"
                        columns={state.columns}
                        data={QuickActions.QuickActions}
                        options={{
                            search: true,
                            sorting: true,
                            pageSize: 20,
                            pageSizeOptions: [20, 30, 50, 100],
                            padding:'dense'
                        }}
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                        handlequickactionsadd(newData);
                                    }, 600);
                                }),
                            onRowUpdate: (newData) =>
                                new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                        handlequickactionsedit(newData);
                                    }, 600);
                                }),
                            onRowDelete: (data) =>
                                new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                        handlequickactionsdelete(data);
                                    }, 600);
                                }),
                        }}

                    /></div>
            }
        </div>
    )
}